<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background:#A6B0A6;\nborder-radius:25px;\nmargin-bottom:90px;\n"' class="container raounded   my-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.vira-yadak.ir\/storage\/assets\/155-1554610_flavoryt-logo-app-store-icon-google-play-icon.png","alt":""},...{}}' :style='"border-radius:35px;\npadding:15px;"' class="col-lg-12" ></m-img></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center mt-3" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="pt-4" >
                <template #default>برای دانلود نسخه اندروید برنامه "ویرا یدک" روی دکمه پایین فشار دهید   </template>
                </m-p><m-div v-bind='{...{},...{}}' :style='""' class="text-center m-2" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/api.geramyan.com\/storage\/123\/app-release.apk","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button v-bind='{...{},...{}}' :style='""' class="bg-secondary" >
                <template #default>دانلود   </template>
                </m-button></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton from '@moeinmdn/miw-alpha-components/src/package/Tags/Button';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mP,mA,mButton },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
